module.exports = __webpack_public_path__ + "static/img/B (8).7e102fc1.png";